import "./cardTool.scss";
import { API_BASE_URL } from "configs/AppConfig";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { TextSlicer } from "functions/textSlicer";

function CardTool({
  title,
  desc,
  image = null,
  link,
  serviceAndToolTranslation,
  isInternal,
  isSystem,
  id
}) {
  const staticImage =
    "https://officesnapshots.com/wp-content/uploads/2016/05/WME-NYC-53-700x525.jpg";


  const currentLocale = useSelector(({ theme }) => theme.locale);

  return (
    <div className="col-12 col-md-6 col-lg-4">
      <div className="card-tool">
        <div className="card-tool-img">
          {isInternal === false ? (
            <a
              href={LabelLangString({
                id: "link",
                currentLocale: currentLocale,
                defaultValue: link,
                translations: serviceAndToolTranslation,
              })}
              target="_blank"
              rel="noreferrer"
              className="card-tool-img_content"
            >
              <h5>
                {LabelLangString({
                  id: "title",
                  currentLocale: currentLocale,
                  defaultValue: title,
                  translations: serviceAndToolTranslation,
                })}
              </h5>
              <p>
                <TextSlicer
                  txt={LabelLangString({
                    id: "shortDescription",
                    currentLocale: currentLocale,
                    defaultValue: desc,
                    translations: serviceAndToolTranslation,
                  })}
                  max={255}
                />
              </p>
            </a>
          ) : (
            <Link
              to={`${!isSystem ? `/servicestools/${id}` : `/${link}`}`}  // isSystem ids === [11, 13, 15, 16, 18, 19, 21]
              className="card-tool-img_content"
            >
              <h5>
                {LabelLangString({
                  id: "title",
                  currentLocale: currentLocale,
                  defaultValue: title,
                  translations: serviceAndToolTranslation,
                })}
              </h5>
              <p>
                <TextSlicer
                  txt={LabelLangString({
                    id: "shortDescription",
                    currentLocale: currentLocale,
                    defaultValue: desc,
                    translations: serviceAndToolTranslation,
                  })}
                  max={255}
                />
              </p>
            </Link>
          )}
          <img
            className=""
            src={image ? `${API_BASE_URL}/${image}` : staticImage}
            alt="service"
            loading="lazy"
          />
        </div>
        <h5 className="card-title">
          <LabelLang
            id="title"
            defaultValue={title}
            translations={serviceAndToolTranslation}
          />
        </h5>
      </div>
    </div>
  );
}

export default CardTool;
